import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const SectionWrapper = ({ title, children, initiallyOpen = true }) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  return (
    <div className="border border-gray-300 rounded-md shadow-sm mb-6">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center px-4 py-3 bg-gray-100 hover:bg-gray-200 transition"
      >
        <h2 className="text-lg font-semibold">{title}</h2>
        {isOpen ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </button>
      {isOpen && <div className="p-4">{children}</div>}
    </div>
  );
};

export default SectionWrapper;
